var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRejectIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 40,
    fill: "#FFE6E5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40 42.5551L31.057 51.4981C30.7224 51.8327 30.2966 52 29.7795 52C29.2624 52 28.8365 51.8327 28.5019 51.4981C28.1673 51.1635 28 50.7376 28 50.2205C28 49.7034 28.1673 49.2776 28.5019 48.943L37.4449 40L28.5019 31.057C28.1673 30.7224 28 30.2966 28 29.7795C28 29.2624 28.1673 28.8365 28.5019 28.5019C28.8365 28.1673 29.2624 28 29.7795 28C30.2966 28 30.7224 28.1673 31.057 28.5019L40 37.4449L48.943 28.5019C49.2776 28.1673 49.7034 28 50.2205 28C50.7376 28 51.1635 28.1673 51.4981 28.5019C51.8327 28.8365 52 29.2624 52 29.7795C52 30.2966 51.8327 30.7224 51.4981 31.057L42.5551 40L51.4981 48.943C51.8327 49.2776 52 49.7034 52 50.2205C52 50.7376 51.8327 51.1635 51.4981 51.4981C51.1635 51.8327 50.7376 52 50.2205 52C49.7034 52 49.2776 51.8327 48.943 51.4981L40 42.5551Z",
    fill: "#F15B59"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRejectIcon);
export default __webpack_public_path__ + "static/media/rejectIcon.7750e151d228bcbdb365f156281ad301.svg";
export { ForwardRef as ReactComponent };